import * as React from "react";

export const Bank = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6992 3.52055C14.8633 3.57534 15 3.73973 15 3.93151V4.91781C15 5.16438 14.7812 5.35616 14.5625 5.35616H1.4375C1.19141 5.35616 1 5.16438 1 4.91781V3.93151C1 3.73973 1.10938 3.57534 1.27344 3.52055L7.67188 1.05479C7.78125 1 7.89062 1 8 1C8.08203 1 8.19141 1 8.30078 1.05479L14.6992 3.52055ZM2.75 6.23288H4.5V10.6164H7.125V6.23288H8.875V10.6164H11.5V6.23288H13.25V10.6164H13.6875C13.9062 10.6164 14.125 10.8356 14.125 11.0548V12.3699H1.875V11.0548C1.875 10.8356 2.06641 10.6164 2.3125 10.6164H2.75V6.23288ZM14.5625 13.2466C14.7812 13.2466 15 13.4658 15 13.6849V14.5616C15 14.8082 14.7812 15 14.5625 15H1.4375C1.19141 15 1 14.8082 1 14.5616V13.6849C1 13.4658 1.19141 13.2466 1.4375 13.2466H14.5625Z"
    />
);
